// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionLog, ActionLogT } from '../tbs/action-log.js';


export class ActionLogEnvelope implements flatbuffers.IUnpackableObject<ActionLogEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ActionLogEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsActionLogEnvelope(bb:flatbuffers.ByteBuffer, obj?:ActionLogEnvelope):ActionLogEnvelope {
  return (obj || new ActionLogEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsActionLogEnvelope(bb:flatbuffers.ByteBuffer, obj?:ActionLogEnvelope):ActionLogEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ActionLogEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

log(obj?:ActionLog):ActionLog|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new ActionLog()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startActionLogEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addLog(builder:flatbuffers.Builder, logOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, logOffset, 0);
}

static endActionLogEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createActionLogEnvelope(builder:flatbuffers.Builder, logOffset:flatbuffers.Offset):flatbuffers.Offset {
  ActionLogEnvelope.startActionLogEnvelope(builder);
  ActionLogEnvelope.addLog(builder, logOffset);
  return ActionLogEnvelope.endActionLogEnvelope(builder);
}

unpack(): ActionLogEnvelopeT {
  return new ActionLogEnvelopeT(
    (this.log() !== null ? this.log()!.unpack() : null)
  );
}


unpackTo(_o: ActionLogEnvelopeT): void {
  _o.log = (this.log() !== null ? this.log()!.unpack() : null);
}
}

export class ActionLogEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public log: ActionLogT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const log = (this.log !== null ? this.log!.pack(builder) : 0);

  return ActionLogEnvelope.createActionLogEnvelope(builder,
    log
  );
}
}
